module.exports = __webpack_public_path__ + "images/emoji/dragon.33a641045be4c5ff358a.png";